import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Refactoring a useReducer to XState, pt1 – CodeWithSwiz 11",
  "description": "XState promises to be like useReducer+Context combined and the simplest way to handle complex state in React apps. But can it deliver? On this episode of #CodeWithSwiz, we gave it a shot.",
  "published": "2020-10-08T00:00:00.000Z",
  "categories": "CodeWithSwiz, Livecoding, Technical, XState",
  "hero": "./img/screenshot-1602169279345.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`XState promises to be like useReducer+Context combined and the simplest way to handle complex state in React apps. But can it deliver? On this episode of #CodeWithSwiz, we gave it a shot.`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a twice-a-week live show. Like a podcast with video and fun hacking. Focused on experiments. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Wednesdays and Sundays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "ftbH90Sd7aU",
      "videostartat": "0"
    }}></lite-youtube>
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`useAuth`}</a>{` was always meant to become `}<em parentName="p">{`the`}</em>{` best way to add authentication to your React and JAMStack apps. Regardless of auth provider.`}</p>
    <p>{`But as time passed, contributors grew (up to 19), pull requests mounted (70 closed or merged 🤘), and bugs got fixed, the codebase became a mess. Hard to reason about, difficult to understand, bleh to work with.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Omg I just opensourced the simplest way to add authentication to your React app.`}<br parentName="p"></br><br parentName="p"></br>{`Handles everything for you. Users, login forms, redirects, sharing state between components. Everything`}<br parentName="p"></br><br parentName="p"></br>{`👉 `}<a parentName="p" {...{
          "href": "https://t.co/cBUWGp5Fz5"
        }}>{`https://t.co/cBUWGp5Fz5`}</a><br parentName="p"></br><br parentName="p"></br>{`github 👉 `}<a parentName="p" {...{
          "href": "https://t.co/eXqB6RerLb"
        }}>{`https://t.co/eXqB6RerLb`}</a><br parentName="p"></br><br parentName="p"></br>{`try 👉 `}<a parentName="p" {...{
          "href": "https://t.co/tl7IHTufGq"
        }}>{`https://t.co/tl7IHTufGq`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/eH5lSFIzKq"
        }}>{`pic.twitter.com/eH5lSFIzKq`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1159865098556432384"
      }}>{`August 9, 2019`}</a></blockquote>
    <p>{`It was time to refactor. And `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/when-your-brain-is-breaking-try-xstate/"
      }}>{`When your brain is breaking, try XState`}</a></p>
    <h2 {...{
      "id": "1-housework"
    }}>{`1: Housework`}</h2>
    <p>{`We started in ep10 with housework.`}</p>
    <p>{`Merge existing PRs, verify tests work, fix lingering bugs. Anything that could lead to merge conflicts after a large change to the codebase.`}</p>
    <p>{`You don't want to leave your contributors hanging.`}</p>
    <lite-youtube {...{
      "videoid": "VQruDDBxyi8",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Among the neglected pull requests we found a fantastic candidate for a useAuth docs page! Thanks Eric Hodges, you're amazing 😍`}</p>
    <p><a parentName="p" {...{
        "href": "https://chakra-ui-test-delta.now.sh/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.88789237668162%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M59%2015l-1%206c-2-1-3-6-1-6%201%200%201-1-1-3-1-2-1-2-2-1l-3%201c-1%200-2%201-2%205%200%205-2%205-3-1%200-5-3-5-2%200%200%204-1%203-3-2-2-7-4-7-6-1l-1%204-2-2c-3-4-5-4-8%200-1%202-2%202-3%201v-1c3%200%202-2%200-3l-3%202c-2%201-2%201-2-1%200-3-3%200-3%203-1%205-2%205-3%200l-1-4c-2%201-2%203-2%208l1%203h7l8-1h1c2%202%2011%201%2011%200%200-2%205-3%206-1%200%201%202%202%206%202h5v-4l1-4v1l1%204c0%203%200%203%204%203%203%200%203-1%203-4%201-5%203-5%203%200%201%206%203%205%203-1%200-5-1-5-3-5s-3-1-3-2l-1-3-1%207m161%2071l-1%203c0%202%200%203-1%202l-2-2c0-2-3-1-3%201-1%201-1%202-3%201-2%200-2%200-2%204s-1%207-3%207l-1-5c0-4-1-6-2-6-2%200-2%201-2%205v5l-3-7c-3-10-5-9-9%201-2%206-2%207-5%207l-4-2c-1-1-1-1%203-1s4%200%204-2l-2-4c-3-4-9-1-9%203%200%202-1%202-3%201-3-2-2-3%200-3l2-1c0-1-1-2-3-2-5%200-7%205-2%208%203%202%203%203-1%203-3%200-3-1-3-6l-1-5c-1%200-2%201-2%205-1%208-3%208-4%200%200-4%200-5-2-5-2%201-3%209-1%2012%201%202%2017%202%2019%200h3c2%203%2011%202%2012%200%201-3%207-3%207%200%201%201%202%202%208%202h7v-6c0-4%200-6%201-5l1%204c0%206%201%207%206%207%203-1%204-1%204-6%201-7%203-6%204%201%200%204%201%205%202%205l1-7v-6h-3c-3%200-4-1-4-3%200-3-2-5-3-3m-80%202l-2%203-1%203-1%205%201%205h13v-4c0-4-2-11-5-13-2-1-2-1-5%201m72%2029l1%204%201-2%201-3%201%203%201%202%201-2h1l3%202c2%200%203-2%200-2-1-1-1-1%201-1l2%202%201%201%201-2%201-3%201%203c0%203%202%203%202-1%200-2%200-2%201%200%201%204%203%204%203%200-1-4-1-6-3-4h-4c-2%200-3%200-3%202h-1c-1-2-4-3-5%200h-1l-2-2-2-1-1-1-1%205m44-3h-2c-1-3-3%200-2%204%200%202%201%203%203%203l3-1h7l1%201%201-2%201-3%201%203%201%202%201-3c-1-4-5-5-6-2%200%201-1%201-2-1h-3c-2%201-4%200-2-2l-1-1-1%202m-120%2044v22l45%201h45v-23l-45-1-45%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6bff21feb2ebaa5f82937b06c71d60d5/ca0a1/kHQSi9pngi2389a.webp 223w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/75680/kHQSi9pngi2389a.webp 445w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/8d1ba/kHQSi9pngi2389a.webp 890w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/3838e/kHQSi9pngi2389a.webp 1335w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/a31b9/kHQSi9pngi2389a.webp 1618w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6bff21feb2ebaa5f82937b06c71d60d5/e92b6/kHQSi9pngi2389a.png 223w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/e66bf/kHQSi9pngi2389a.png 445w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/4ef49/kHQSi9pngi2389a.png 890w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/4e814/kHQSi9pngi2389a.png 1335w", "/static/6bff21feb2ebaa5f82937b06c71d60d5/49ee2/kHQSi9pngi2389a.png 1618w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/6bff21feb2ebaa5f82937b06c71d60d5/4ef49/kHQSi9pngi2389a.png",
              "alt": "kHQSi9pngi2389a",
              "title": "kHQSi9pngi2389a",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`You can try it on his demo deploy 👆`}</p>
    <h2 {...{
      "id": "2-identify-possible-states"
    }}>{`2: Identify possible states`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/33861427851283ef239c3a1a231f71c6/7960f/XState-visualization-of-the-useAuth-state-machineb9h548.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "39.01345291479821%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'156\\'%20viewBox=\\'0%200%20400%20156\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M389%2078v65H198L8%20144h190l192-1V77l-1-64v65M26%2019c0%202%200%202-1%200h-5c-2-1-6-1-6%201s0%202-1%200c-1-3-2-3-2%200%200%202%201%203%204%203h17c3%200%204%200%204-2h1l2%202%202-2h1c0%203%202%202%202%200%200-3-4-5-8-3h-1l-1%202-1%203v-3c0-2%200-2-1-1-2%202-2%202-2%200-1-3-3-3-4%200M16%2044c-2%201-1%203%204%207l4%207c0%205-1%205%2037%205h36v-6c0-6%203-7%207-2%202%202%202%202%2013%202l14-1c1-2%202-2%202-1%201%201%201%200%201-1-1-2-1-2%207-2l8%201h2c2-2%202-2%200-3h-2l-8%201h-8l-2-4c-1-2-3-3-3-2l-12%201c-11%200-11%200-13%203s-6%203-6%200v-2l-36-1c-35%200-36%200-36%202l-3%202c-2%201-3-1-2-3%202-2-2-6-4-3m244%203l-1%203c0%202-6%201-6-1a242%20242%200%20000%2032c0-15%200-15%202-15l4%202c2%203%202%203%2020%203l19%201-1%2010-1%2013-1%203h-79a824%20824%200%2001-92%200l-10%201h21v5l1%206V99h20c14%200%2020%200%2019%201h1a2777%202777%200%2001135-2h-14v-2l2-14V71h10c9%200%2010%200%2012-2%200-2%202-3%203-3%201-1%201-1-1-1l-2-1c0-3-3-4-13-4h-10v-3l-1-2v5h-17c-18%200-18%200-20%203l-4%202c-3%200-3%200-3-6%200-7%200-7%203-7l4%203c3%203%2027%203%2030%200l4-3%203-1h-3l-4-2c0-2-1-3-15-3l-15%201M26%2055v7h69V47H26v8m129%2016v25h98l-49-1h-48V71l-1-24v24M49%2052l-1%201-1%201c0%202-2%201-2-1-1-1-1%200-1%201%200%203%204%204%204%201h1l2%202%202-2h1c0%201%201%202%204%202%204%200%205-1%205-2h1c0%202%2016%203%2016%200h1c0%201%201%202%206%202h6v-3c0-3-1-4-4-1h-2l-2-1H61l-4%201h-1l-7-1m119%200l-2%203-1-1-1-2v2c0%203%204%204%204%201h1l2%202%202-2h1c0%201%201%202%204%202%204%200%205-1%205-2h1c0%202%2016%203%2016%200h1c0%204%204%202%204-1s0-3-2-3l-2%201h-10c0-2-2-1-2%202l-1%203v-3c0-3-2-4-2-2h-4l-5%201h-1c-2-2-6-2-8-1m17%2013l-2%201c-2-1-4%201-2%202v2c1%202%203%200%203-2v-1l1%201c0%203%208%203%208%200l1%201c1%202%201%202%203%201h5c3%201%203%201%204-1l1-1c0%202%203%203%203%201l1-2%201%202%201%201h1c2%201%206%200%206-2l1%201c1%201%201%201%201-1s-1-2-4-2h-4l-2-1h-4c0-1-3%201-3%203l-1%201v-1l-1-2-1%202-1-1-2-3-2%203c-1%202-1%202-1%200s0-2-2-2l-2%201v2l-1-1-2-2-2%202c0%202%200%202-1%200l-1-2m7%2018c0%202%200%202-1%201%200-2-1-2-5-2h-4c-1-2-6%200-6%202%200%203%201%203%206%203h9l2-1h2c3%201%206%201%206-1l1-2v2c0%202%204%203%204%200v-2l1%202c0%202%200%202%201%201h1c0%202%205%201%206-1%200-2%200-2%201%200l1%203v-3c0-3%200-3-5-3l-6-1h-2l-1%201c-2%200-3%200-3%202h-1l-1-2-1%202-1-1-2-3-2%203m-98%2028l-6%203c-2-1-2-1-2%205v6l1-5c0-6%203-7%206-2l2%202h16c16%200%2017-1%2017-3l4-2%202-1h-2c-2%200-3%200-3-2-1-3-5-4-19-4H97l-3%203m-55%204l-1%201-2%202h-1c-1-2-1-2-1%200%200%204%204%204%204%201l1-2v2c0%203%203%202%204%200s1-2%201%200%205%203%206%201h1c0%202%202%201%202-1s0-2%201%200c1%203%2016%203%2016%200%201-2%201-2%201%200s6%203%206%201h1c3%202%204%201%204-3%200-2%200-3-1-2-1%202-8%202-9%200h-1l-3%201-2%202-1%201-2-1h1l1-1-2-1c-1%201-2%200-2-1l-1-1-1%201-9%201-7-1h-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/33861427851283ef239c3a1a231f71c6/ca0a1/XState-visualization-of-the-useAuth-state-machineb9h548.webp 223w", "/static/33861427851283ef239c3a1a231f71c6/75680/XState-visualization-of-the-useAuth-state-machineb9h548.webp 445w", "/static/33861427851283ef239c3a1a231f71c6/8d1ba/XState-visualization-of-the-useAuth-state-machineb9h548.webp 890w", "/static/33861427851283ef239c3a1a231f71c6/15a27/XState-visualization-of-the-useAuth-state-machineb9h548.webp 1274w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/33861427851283ef239c3a1a231f71c6/e92b6/XState-visualization-of-the-useAuth-state-machineb9h548.png 223w", "/static/33861427851283ef239c3a1a231f71c6/e66bf/XState-visualization-of-the-useAuth-state-machineb9h548.png 445w", "/static/33861427851283ef239c3a1a231f71c6/4ef49/XState-visualization-of-the-useAuth-state-machineb9h548.png 890w", "/static/33861427851283ef239c3a1a231f71c6/7960f/XState-visualization-of-the-useAuth-state-machineb9h548.png 1274w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/33861427851283ef239c3a1a231f71c6/4ef49/XState-visualization-of-the-useAuth-state-machineb9h548.png",
                "alt": "XState visualization of the useAuth state machine",
                "title": "XState visualization of the useAuth state machine",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`XState visualization of the useAuth state machine`}</figcaption>{`
  `}</figure></p>
    <p>{`Refactoring a `}<inlineCode parentName="p">{`useReducer`}</inlineCode>{` to `}<a parentName="p" {...{
        "href": "https://xstate.js.org/"
      }}>{`XState`}</a>{` starts by identifying your states. Each `}<inlineCode parentName="p">{`case`}</inlineCode>{` corresponds to a transition between states.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`export const authReducer = (
  state: AuthState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case "login":
    // ...
    case "logout":
    // ...
    case "stopAuthenticating":
    // ...
    case "startAuthenticating":
    // ...
    case "error":
    // ...
    default:
      return state;
  }
};
`}</code></pre>
    <p>{`Your XState state machine will have N-1 states.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`const authMachine = Machine<AuthState>(
  {
    id: "useAuth",
    initial: "unauthenticated",
    // ...
    states: {
      unauthenticated: {},
      authenticating: {},
      authenticated: {},
      error: {},
    },
  }
  // ...
);
`}</code></pre>
    <p>{`A user can be either `}<inlineCode parentName="p">{`unauthenticated`}</inlineCode>{`, `}<inlineCode parentName="p">{`authenticating`}</inlineCode>{`, `}<inlineCode parentName="p">{`authenticated`}</inlineCode>{`, or there's an `}<inlineCode parentName="p">{`error`}</inlineCode>{`. No other state exists.`}</p>
    <h2 {...{
      "id": "3-define-transitions-between-states"
    }}>{`3: Define transitions between states`}</h2>
    <p>{`You can read transitions from the reducer. Each `}<inlineCode parentName="p">{`case`}</inlineCode>{` becomes an XState transition.`}</p>
    <p>{`Harder is identifying what they transition from and to. Reducers hide that info in the gaggle of returned state. `}<em parentName="p">{`You`}</em>{` have to read the code and understand its intent.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`states: {
    unauthenticated: {
        on: {
            LOGIN: "authenticating"
        }
    },
    authenticating: {
        on: {
            ERROR: "error",
            AUTHENTICATED: "authenticated"
        },
    },
    authenticated: {
        on: {
            LOGOUT: "unauthenticated"
        }
    },
    error: {}
}
`}</code></pre>
    <p>{`If you're `}<inlineCode parentName="p">{`unauthenticated`}</inlineCode>{` and trigger `}<inlineCode parentName="p">{`LOGIN`}</inlineCode>{`, you get to `}<inlineCode parentName="p">{`authenticating`}</inlineCode>{`. From there you can either get `}<inlineCode parentName="p">{`AUTHENTICATED`}</inlineCode>{` or an `}<inlineCode parentName="p">{`ERROR`}</inlineCode>{`. To get out of the `}<inlineCode parentName="p">{`authenticated`}</inlineCode>{` state, you have to `}<inlineCode parentName="p">{`LOGOUT`}</inlineCode>{`.`}</p>
    <p>{`Isn't that more readable?`}</p>
    <p><a parentName="p" {...{
        "href": "https://xstate.js.org/viz/"
      }}>{`XState's visualizer`}</a>{` even draws helpful diagrams.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/33861427851283ef239c3a1a231f71c6/7960f/XState-visualization-of-the-useAuth-state-machinege50fd.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "39.01345291479821%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'156\\'%20viewBox=\\'0%200%20400%20156\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M389%2078v65H198L8%20144h190l192-1V77l-1-64v65M26%2019c0%202%200%202-1%200h-5c-2-1-6-1-6%201s0%202-1%200c-1-3-2-3-2%200%200%202%201%203%204%203h17c3%200%204%200%204-2h1l2%202%202-2h1c0%203%202%202%202%200%200-3-4-5-8-3h-1l-1%202-1%203v-3c0-2%200-2-1-1-2%202-2%202-2%200-1-3-3-3-4%200M16%2044c-2%201-1%203%204%207l4%207c0%205-1%205%2037%205h36v-6c0-6%203-7%207-2%202%202%202%202%2013%202l14-1c1-2%202-2%202-1%201%201%201%200%201-1-1-2-1-2%207-2l8%201h2c2-2%202-2%200-3h-2l-8%201h-8l-2-4c-1-2-3-3-3-2l-12%201c-11%200-11%200-13%203s-6%203-6%200v-2l-36-1c-35%200-36%200-36%202l-3%202c-2%201-3-1-2-3%202-2-2-6-4-3m244%203l-1%203c0%202-6%201-6-1a242%20242%200%20000%2032c0-15%200-15%202-15l4%202c2%203%202%203%2020%203l19%201-1%2010-1%2013-1%203h-79a824%20824%200%2001-92%200l-10%201h21v5l1%206V99h20c14%200%2020%200%2019%201h1a2777%202777%200%2001135-2h-14v-2l2-14V71h10c9%200%2010%200%2012-2%200-2%202-3%203-3%201-1%201-1-1-1l-2-1c0-3-3-4-13-4h-10v-3l-1-2v5h-17c-18%200-18%200-20%203l-4%202c-3%200-3%200-3-6%200-7%200-7%203-7l4%203c3%203%2027%203%2030%200l4-3%203-1h-3l-4-2c0-2-1-3-15-3l-15%201M26%2055v7h69V47H26v8m129%2016v25h98l-49-1h-48V71l-1-24v24M49%2052l-1%201-1%201c0%202-2%201-2-1-1-1-1%200-1%201%200%203%204%204%204%201h1l2%202%202-2h1c0%201%201%202%204%202%204%200%205-1%205-2h1c0%202%2016%203%2016%200h1c0%201%201%202%206%202h6v-3c0-3-1-4-4-1h-2l-2-1H61l-4%201h-1l-7-1m119%200l-2%203-1-1-1-2v2c0%203%204%204%204%201h1l2%202%202-2h1c0%201%201%202%204%202%204%200%205-1%205-2h1c0%202%2016%203%2016%200h1c0%204%204%202%204-1s0-3-2-3l-2%201h-10c0-2-2-1-2%202l-1%203v-3c0-3-2-4-2-2h-4l-5%201h-1c-2-2-6-2-8-1m17%2013l-2%201c-2-1-4%201-2%202v2c1%202%203%200%203-2v-1l1%201c0%203%208%203%208%200l1%201c1%202%201%202%203%201h5c3%201%203%201%204-1l1-1c0%202%203%203%203%201l1-2%201%202%201%201h1c2%201%206%200%206-2l1%201c1%201%201%201%201-1s-1-2-4-2h-4l-2-1h-4c0-1-3%201-3%203l-1%201v-1l-1-2-1%202-1-1-2-3-2%203c-1%202-1%202-1%200s0-2-2-2l-2%201v2l-1-1-2-2-2%202c0%202%200%202-1%200l-1-2m7%2018c0%202%200%202-1%201%200-2-1-2-5-2h-4c-1-2-6%200-6%202%200%203%201%203%206%203h9l2-1h2c3%201%206%201%206-1l1-2v2c0%202%204%203%204%200v-2l1%202c0%202%200%202%201%201h1c0%202%205%201%206-1%200-2%200-2%201%200l1%203v-3c0-3%200-3-5-3l-6-1h-2l-1%201c-2%200-3%200-3%202h-1l-1-2-1%202-1-1-2-3-2%203m-98%2028l-6%203c-2-1-2-1-2%205v6l1-5c0-6%203-7%206-2l2%202h16c16%200%2017-1%2017-3l4-2%202-1h-2c-2%200-3%200-3-2-1-3-5-4-19-4H97l-3%203m-55%204l-1%201-2%202h-1c-1-2-1-2-1%200%200%204%204%204%204%201l1-2v2c0%203%203%202%204%200s1-2%201%200%205%203%206%201h1c0%202%202%201%202-1s0-2%201%200c1%203%2016%203%2016%200%201-2%201-2%201%200s6%203%206%201h1c3%202%204%201%204-3%200-2%200-3-1-2-1%202-8%202-9%200h-1l-3%201-2%202-1%201-2-1h1l1-1-2-1c-1%201-2%200-2-1l-1-1-1%201-9%201-7-1h-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/33861427851283ef239c3a1a231f71c6/ca0a1/XState-visualization-of-the-useAuth-state-machinege50fd.webp 223w", "/static/33861427851283ef239c3a1a231f71c6/75680/XState-visualization-of-the-useAuth-state-machinege50fd.webp 445w", "/static/33861427851283ef239c3a1a231f71c6/8d1ba/XState-visualization-of-the-useAuth-state-machinege50fd.webp 890w", "/static/33861427851283ef239c3a1a231f71c6/15a27/XState-visualization-of-the-useAuth-state-machinege50fd.webp 1274w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/33861427851283ef239c3a1a231f71c6/e92b6/XState-visualization-of-the-useAuth-state-machinege50fd.png 223w", "/static/33861427851283ef239c3a1a231f71c6/e66bf/XState-visualization-of-the-useAuth-state-machinege50fd.png 445w", "/static/33861427851283ef239c3a1a231f71c6/4ef49/XState-visualization-of-the-useAuth-state-machinege50fd.png 890w", "/static/33861427851283ef239c3a1a231f71c6/7960f/XState-visualization-of-the-useAuth-state-machinege50fd.png 1274w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/33861427851283ef239c3a1a231f71c6/4ef49/XState-visualization-of-the-useAuth-state-machinege50fd.png",
                "alt": "XState visualization of the useAuth state machine",
                "title": "XState visualization of the useAuth state machine",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`XState visualization of the useAuth state machine`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "4-move-your-state-into-context"
    }}>{`4: Move your state into context`}</h2>
    <p>{`Final step is moving what you used to think of as "state" into the state machine `}<inlineCode parentName="p">{`context`}</inlineCode>{`.`}</p>
    <p>{`You can think of context as the meta state. The application state that your state machine states correspond to.`}</p>
    <p>{`Best copied from your TypeScript definition of the reducer's state ✌️`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`const authMachine = Machine<AuthState>(
    {
        // ...
                context: {
                    user: {},
                    expiresAt: null,
                    authResult: null,
                    isAuthenticating: false,
                    error: undefined,
                    errorType: undefined
                },
`}</code></pre>
    <p>{`XState docs call this the infinite state next to the finite state of a state machine. I like "application state".`}</p>
    <p>{`This is where you store the values that `}<em parentName="p">{`you`}</em>{` care about.`}</p>
    <p>{`On stream we got as far as manipulating the `}<inlineCode parentName="p">{`isAuthenticating`}</inlineCode>{` flag as a side-effect of the `}<inlineCode parentName="p">{`authenticating`}</inlineCode>{` state. Might be unnecessary now that's an explicit state, but made for a good playground.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`const authMachine = Machine<AuthState>(
  {
    // ...
    states: {
      // ...
      authenticating: {
        on: {
          ERROR: "error",
          AUTHENTICATED: "authenticated",
        },
        entry: ["startAuthenticating"],
        exit: ["stopAuthenticating"],
      },
      // ...
    },
  },
  {
    actions: {
      startAuthenticating: assign((context) => {
        return {
          isAuthenticating: true,
        };
      }),
      stopAuthenticating: assign((context) => {
        return {
          isAuthenticating: false,
        };
      }),
    },
  }
);
`}</code></pre>
    <p>{`Adding `}<inlineCode parentName="p">{`entry`}</inlineCode>{` and `}<inlineCode parentName="p">{`exit`}</inlineCode>{` effects to the `}<inlineCode parentName="p">{`AUTHENTICATING`}</inlineCode>{` action tells XState to call the `}<inlineCode parentName="p">{`startAuthenticating`}</inlineCode>{` and `}<inlineCode parentName="p">{`stopAuthenticating`}</inlineCode>{` actions.`}</p>
    <p>{`They're set up with the `}<inlineCode parentName="p">{`assign()`}</inlineCode>{` action creator from XState. I figured out this exact incantation off stream. Docs were confusing as heck on stream and making it play with TypeScript was hell.`}</p>
    <h2 {...{
      "id": "5-accessing-xstate-context-to-read-application-state"
    }}>{`5: Accessing XState context to read application state`}</h2>
    <p>{`You can't access context directly.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Yep that's exactly it (or .subscribe(...))`}<br parentName="p"></br><br parentName="p"></br>{`You can't directly read state - local, isolated state is a core tenet of the Actor model. But you can "remember" the last emitted state.`}<br parentName="p"></br><br parentName="p"></br>{`For example, you can't know where a hurricane is, but you can know where it was last reported.`}</p>{`— David K. 🎹 (@DavidKPiano) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/DavidKPiano/status/1314201314193076226"
      }}>{`October 8, 2020`}</a></blockquote>
    <p>{`That means you'll have to either `}<inlineCode parentName="p">{`.subscribe`}</inlineCode>{` to changes or use a dirty side effect in an `}<inlineCode parentName="p">{`.onTransition`}</inlineCode>{` call.`}</p>
    <p>{`Here's a test that works to verify the authenticating entry side-effect.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`it("changes isAuthenticating to true", () => {
  let context = { isAuthenticating: false };

  authMachine
    .onTransition((state) => {
      context = state.context;
    })
    .send("LOGIN");

  expect(context.isAuthenticating).toBe(true);
});
`}</code></pre>
    <p>{`Notice how I'm storing a value in a variable when `}<inlineCode parentName="p">{`onTransition`}</inlineCode>{` runs. That can get messy and I'm not sure yet how we'll use it to make the `}<inlineCode parentName="p">{`authMachine`}</inlineCode>{` a drop-in replacement for `}<inlineCode parentName="p">{`authReducer`}</inlineCode>{`.`}</p>
    <p>{`Want to make this refactor invisible to users of `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`useAuth`}</a>{` 😊`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`Fin`}</h2>
    <p>{`In conclusion, XState is like an inverted useReducer. Cases become transitions, the space between cases becomes state machine states, reducer state becomes context.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/LxPsfUhFxwRRC/giphy-loop.mp4?cid=7cf28b0fuhvjpk1agf58e9vyojd3541h13lz1h2jjsguobn5&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      